import validator from 'validator';

function AddEditWeeklyChallangesValidation(data) {
  console.log('++++++++++++++++ , AddEditWeeklyChallangesValidation , data', data);
  const errors = {};
  if (validator.isEmpty(data.week.trim())) errors.week = 'Please select week.';

  return { errors, isValid: Object.keys(errors).length <= 0 };
}

export default AddEditWeeklyChallangesValidation;
